import { render, staticRenderFns } from "./VariantShadow.vue?vue&type=template&id=15267ae2&"
import script from "./VariantShadow.vue?vue&type=script&lang=js&"
export * from "./VariantShadow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports